(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/pix-mix/components/pix-mix-tab-view/assets/javascripts/pix-mix-tab-view.js') >= 0) return;  svs.modules.push('/modules/pix-mix/components/pix-mix-tab-view/assets/javascripts/pix-mix-tab-view.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useCallback,
  useEffect,
  useRef,
  useState
} = React;
const {
  getDisplayName
} = svs.utils.products;
const {
  ReactButton: Button
} = svs.ui;
const {
  PixMixItem
} = svs.pix_mix.components;
const {
  removeFromQueryParams
} = svs.pix_mix.components.common.helpers;
const {
  usePixMixen
} = svs.pix_mix.components.common.hooks;
const {
  QuickplayModal
} = svs.components.sport.quickplayModal;
const {
  createStandardPaymentFlow
} = svs.components.wagerPaymentFlow.standardFlow;
const {
  executePayment
} = svs.components.wagerPaymentFlow.executePayment;
const {
  dialog
} = svs.components;
const {
  Confirm
} = dialog;
const {
  useInitialFocus
} = svs.components.lbUtils;
const {
  Tabs,
  TabList,
  Tab,
  TabPanel
} = svs.components.lbUi.tabs;
const logger = new svs.core.log.Logger('svs.pix_mix.Pixmixen');
const STORAGE_BUNDLE_SIZE_SELECTED = 'pixmixen.bundle_size_selected';
const {
  getPixHandler
} = svs.components.sport.pixHandler;
const PixmixTabView = _ref => {
  var _pixData$fulfilled2;
  let {
    bundles,
    refreshDraws
  } = _ref;
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const ENTER_ANIMATION_DELAY = 100;
  const cachedSize = sessionStorage.getItem(STORAGE_BUNDLE_SIZE_SELECTED);
  const isPaymentInProgress = useRef(false);
  const isHvsRemoved = svs.core.detect.feature('ft-hvs-close');
  const cntRef = useRef(null);
  const {
    initialFocus,
    setInitialFocus
  } = useInitialFocus();
  logger.debug("Cached bundle size is: ".concat(cachedSize));
  if (!cachedSize) {
    logger.debug("Using default bundle size: ".concat(bundles === null || bundles === void 0 ? void 0 : bundles[0].tag));
  }
  const [selectedBundleSize, setSelectedBundleSize] = useState(cachedSize || (bundles === null || bundles === void 0 ? void 0 : bundles[0].tag));
  const [showQuickPlay, setShowQuickPlay] = useState(false);
  const [pixProduct, setPixProduct] = useState(undefined);
  const retry = useRef(false);
  const payButtonRef = useRef(null);
  const products = bundles.find(bundle => bundle.tag === selectedBundleSize).products;
  const {
    pixData,
    refreshPixes,
    unsetPixes
  } = usePixMixen(products);
  logger.debug('usePixMixen for:', products, ' result:', pixData);
  const [isPendingPayment, setIsPendingPayment] = useState(false);
  const initiator = useRef();
  const displayQuickPlayModal = useCallback((product, currentTarget) => {
    const event = {
      category: 'PIX-mixen',
      action: 'Product click',
      opt_label: getDisplayName(product.id)
    };
    svs.components.analytics.trackEvent(event);
    setPixProduct(_objectSpread({}, product));
    initiator.current = currentTarget;
    logger.debug("Set product to ".concat(getDisplayName(product.id), " and open Quickplay Modal"));
    setShowQuickPlay(true);
  }, []);
  const onModalClose = useCallback(() => {
    setShowQuickPlay(false);
    setPixProduct(undefined);
  }, []);
  const missingWagerError = () => {
    dialog.api.add(new Confirm({
      branding: svs.components.dialog.branding.SPORT,
      type: svs.components.dialog.type.ERROR,
      title: 'Nu blev det fel!',
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: 'Något gick fel när betalningen skulle göras. Kontrollera pixarna och försök igen.'
      }],
      actions: [{
        title: 'Okej',
        showLoader: true,
        callback() {
          svs.components.dialog.api.close();
        }
      }]
    }));
  };
  const trackWagerEvent = useCallback(() => {
    svs.components.analytics.trackEvent({
      category: 'Wager',
      action: 'Paid',
      opt_label: "pixmixen-".concat(selectedBundleSize)
    });
  }, [selectedBundleSize]);

  const handlePixPayment = useCallback(async () => {
    var _payButtonRef$current, _wagers;
    if (isPaymentInProgress.current) {
      return;
    }
    setInitialFocus((_payButtonRef$current = payButtonRef.current) === null || _payButtonRef$current === void 0 ? void 0 : _payButtonRef$current.id);
    isPaymentInProgress.current = true;
    const bundle = bundles.find(bundle => bundle.tag === selectedBundleSize);
    logger.debug('handlePixPayment:', bundle);
    let wagers = [];
    const pixHandler = getPixHandler({
      isPixMix: true
    });
    wagers = bundle.products.map(_ref2 => {
      let {
        id: productId
      } = _ref2;
      return pixHandler.createPixWager({
        productId,
        bagType: bundle.id
      });
    });
    logger.debug('Converted wagers:', wagers);
    if (!((_wagers = wagers) !== null && _wagers !== void 0 && _wagers.length)) {
      if (!retry.current) {
        retry.current = true;
        logger.debug('Retry, refresh pixes');
        refreshPixes();
      } else {
        retry.current = false;
        logger.debug('Retry failed, throw error');
        missingWagerError();
      }
      return;
    }
    const paymentBuilder = await createStandardPaymentFlow({
      config: {
        haltPaymentOnException: false
      },
      wagers
    });
    setIsPendingPayment(true);
    const [result, error] = await executePayment(paymentBuilder, {
      userContext: {
        returnQuery: {
          action: 'pay'
        },
        bag: "pixmixen-".concat(bundle.tag),
        uniqueTrackingId: Math.floor(Math.random() * Date.now()).toString(36),
        callback: initialFocus
      }
    });
    isPaymentInProgress.current = false;
    if (error) {
      logger.debug("".concat(error.name, ": ").concat(error));
      setIsPendingPayment(false);
      if (!result.getPaidPayableItems().length) {
        return;
      }
    }
    refreshDraws();
    trackWagerEvent();
    unsetPixes(refreshPixes);
  }, [bundles, refreshDraws, refreshPixes, selectedBundleSize, trackWagerEvent, unsetPixes, initialFocus, setInitialFocus]);

  const renderBundles = size => {
    var _pixData$rejected;
    const bundle = bundles.find(bundle => bundle.tag === size);
    if ((pixData === null || pixData === void 0 || (_pixData$rejected = pixData.rejected) === null || _pixData$rejected === void 0 ? void 0 : _pixData$rejected.length) > 0) {
      const mappedErrors = pixData.rejected.map(error => error.message);
      logger.info('Rejected pixes:', mappedErrors.join(', '));
    }
    return bundle.products.map((product, index) => {
      var _pixData$fulfilled;
      return React.createElement(PixMixItem, {
        delay: index * ENTER_ANIMATION_DELAY,
        disabled: !(pixData !== null && pixData !== void 0 && (_pixData$fulfilled = pixData.fulfilled) !== null && _pixData$fulfilled !== void 0 && _pixData$fulfilled.find(fulfilled => {
          var _fulfilled$drawRespon;
          return (fulfilled === null || fulfilled === void 0 || (_fulfilled$drawRespon = fulfilled.drawResponse) === null || _fulfilled$drawRespon === void 0 ? void 0 : _fulfilled$drawRespon.productId) === product.id;
        })) || isPendingPayment,
        key: product.id,
        onClick: displayQuickPlayModal,
        product: product
      });
    });
  };
  const getPayButtonAriaLabel = () => {
    const bundle = bundles.find(bundle => bundle.tag === selectedBundleSize);
    return "Betala ".concat(bundle.label);
  };
  const getTabListAriaLabel = () => {
    const bundle = bundles.find(bundle => bundle.tag === selectedBundleSize);
    const productNames = bundle.products.reduce((acc, product, index) => {
      const name = product.branding.displayName;
      if (index === 0) {
        return name;
      } else if (index === bundle.products.length - 1) {
        return "".concat(acc, " och ").concat(name);
      }
      return "".concat(acc, ", ").concat(name);
    }, '');
    return "Pix-mix paketv\xE4ljare med ".concat(bundles.length, "st produkter per paket (").concat(productNames, "). Klicka p\xE5 en produkt f\xF6r att granska eller generera ny pix");
  };

  useEffect(() => {
    if (retry.current) {
      handlePixPayment();
    }
  }, [pixData, handlePixPayment]);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    if (pixData && queryParams.get('action') === 'pay') {
      removeFromQueryParams('action');
      if (isLoggedIn) {
        handlePixPayment();
      }
    }
  }, [pixData, handlePixPayment, isLoggedIn]);
  return selectedBundleSize && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "pix-mix-tab-container",
    ref: cntRef
  }, React.createElement(Tabs, {
    className: "pix-mix-tab-view",
    defaultIndex: bundles.findIndex(bundle => bundle.tag === selectedBundleSize)
  }, React.createElement(TabList, {
    ariaLabel: getTabListAriaLabel(),
    className: "btn-group btn-group-block"
  }, bundles.map(bundle => React.createElement(Tab, {
    className: "pix-mix-tab-menu-btn",
    key: bundle.tag,
    onClick: () => {
      setSelectedBundleSize(bundle.tag);
      sessionStorage.setItem(STORAGE_BUNDLE_SIZE_SELECTED, bundle.tag);
    }
  }, bundle.label))), bundles.map(bundle => React.createElement(TabPanel, {
    key: bundle.tag
  }, React.createElement("div", {
    className: "pix-mix-tab-content ".concat(isHvsRemoved ? 'hvs-removed' : '')
  }, renderBundles(bundle.tag))))), React.createElement("div", {
    className: "pix-mix-tab-actions"
  }, React.createElement(Button, {
    "aria-disabled": isPendingPayment || !(pixData !== null && pixData !== void 0 && (_pixData$fulfilled2 = pixData.fulfilled) !== null && _pixData$fulfilled2 !== void 0 && _pixData$fulfilled2.length),
    "aria-label": getPayButtonAriaLabel(),
    block: true,
    className: isPendingPayment ? 'pix-mix-tab-actions-btn-disabled' : '',
    elemRef: payButtonRef,
    focus: true,
    id: "pix-mix-pay-button",
    onClick: handlePixPayment
  }, "Betala"))), showQuickPlay && React.createElement(QuickplayModal, {
    branding: pixProduct.branding.brand[0],
    drawNumber: pixProduct.drawNumber,
    hasPortal: true,
    hasSaveButton: true,
    initiator: initiator.current,
    isPixMix: true,
    onModalClose: onModalClose,
    productId: pixProduct.id,
    rowPrice: pixProduct.rowPrice,
    systemCost: pixProduct.systemCost,
    systemType: pixProduct.systemType,
    wallet: undefined
  }));
};
setGlobal('svs.pix_mix.components.PixmixTabView', PixmixTabView);

 })(window);